<template>
  <div class="container">

    <div class="div1"><img  class="aaaa" src="../../assets/17.png" alt=""></div>
    <div class="div2">
      <img class="ww" src="../../assets/16.png" alt="">
      <span class="spanp">400-081-9881</span>
    </div>

   

    <div class="div4">
    <div style="float:left;">
      <a href="#/zou/a"><span>走进加农正和</span></a>
              
              <ul style="margin-top: 1vw;">
              <a href="#/zou/a"><li>加农正和简介</li></a>
              <a href="#/zou/b"><li>总裁介绍</li></a>
              <a href="#/zou/g"> <li>领导关怀</li></a>
              <a href="#/zou/c"><li>企业荣誉</li></a>
              <a href="#/zou/e"><li>产品中心</li></a>
              <a href="#/zou/f"> <li>发展历程</li></a>
              <a href="#/zou/d"> <li>企业文化</li></a>
</ul>
    </div>
    <div style="float:left;">
              <a href="#/xin"><span>新闻资讯</span></a>
              <ul style="margin-top: 1vw;">
    <a href="#/xin"> <li>加农正和新闻</li></a>
    <a href="#/xin"> <li>行业新闻</li></a>
    <a href="#/xin"> <li>媒体视界</li></a>
  </ul>
    </div>
    <div style="float:left;">
              <a href="#/chan/first"> <span>产品与服务</span></a>
              <ul style="margin-top: 1vw;">
            <a href="#/chan/first"> <li>产品中心</li></a>
            <a href="#/chan/second"><li>PTT养猪学习院</li></a>
            <a href="#/chan/third"><li>PSY应用研究院</li></a>
            <a href="#/chan/fourth"> <li>1+3精益生产咨询</li></a>
            <!-- <a href="#/chan/fifth"> <li>产业服务</li></a> -->
  </ul>
    </div>
    <div style="float:left;">
              <a  href="#/ke/left"><span>科技创新</span></a>
              <ul style="margin-top: 1vw;">
    <a href="#/ke/left">  <li>科研创新</li></a>
      <a href="#/ke/center"> <li>科研实力</li></a>
        <a href="#/ke/right">  <li>科研成果</li></a>
        <a href="#/ke/zhishi">  <li>知识成果</li></a>
  </ul>
    </div>
    <div style="float:left;">
              <a href="#/ren">  <span>人才中心</span></a>
    </div>
    <div style="float:left;">
              <a href="#/she"><span>社会责任</span></a>
    </div>
    <div style="float:left;">
              <a href="#/lian"> <span>联系我们</span></a>
    </div>
  </div>
  <div class="qrcodeDiv">
      <div class="span1"><img src="../../assets/wx.png" alt="">
      <span class="span3">湖南加农正和微信公众号</span>
      </div>
      <div class="span1" ><img class="bbbb" src="../../assets/ptt_gzh.jpg" alt="">
      <span class="span3">PTT养猪学习院微信公众号</span>
      </div>
      <div class="span1" ><img class="bbbb" src="../../assets/psy.jpg" alt="">
      <span class="span3">PSY应用研究院微信公众号</span>
      </div>
      <div class="span1" ><img class="bbbb" src="../../assets/ptt.jpg" alt="">
        <span class="span3">PTT养猪学习院小程序</span>
      </div>
      <div class="span1" ><img class="bbbb" src="../../assets/xcx.jpg" alt="">
        <span class="span3">PTT养猪学习院APP</span>
      </div>
    </div>
    <div class="span5"> <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">湘ICP备17001806号</a> <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43018102000248">湘公网安备43018102000248号</a></div>

    <!-- <div class="div6">
      <a class="span" href=""  target="_blank">集团招投标</a>
      <a class="span" href="http://39.106.208.233//esweb/index.aspx"  target="_blank">勤哲</a>
      <a class="span" href="http://mail.vicagroup.com.cn/"  target="_blank">邮箱</a> -->
      <!--<a class="span" href="http://gs.vicagroup.com.cn/cwbase/web/login.aspx"  target="_blank">费用报销</a>-->
      <!-- <a class="span" href="https://www.fxiaoke.com/pc-login/build/login.html"  target="_blank">云平台</a>
      <a class="span" href="https://dwj.study.moxueyuan.com/login/login.html"  target="_blank">伟嘉商学院</a>
      <a class="span" href="http://www.vicagroup.com.cn/index.php/Home/Feedbacks/index.html"  target="_blank">留言信箱</a>
      <a class="span" href="https://uweb.umeng.com/v1/login.php?siteid=1619107"  target="_blank">站长统计</a>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: "Bottom"
  }
</script>

<style scoped>
.qrcodeDiv{
    padding: 2vw 8vw;
    width: 42vw;
    grid-template-columns:  20% 20% 20% 20% 20%;
    /*repeat重复函数*/
    grid-template-rows:repeat(5,20%);

    display: grid;
  }
  .container{
    width: 100%;
    height: 88vh;
    background-color: #4F4F4F;
  }
  .div1{
    text-align: center;
    padding-top: 2vw;
  }
 /deep/ .aaaa{
    width: 10vw!important;
    height: 2.5417vw!important;
  }
  .div2{
    text-align: center;
    padding-top: 2vw;

  }
 /deep/ .ww{
    width: 1.4vw!important;
    height: 1.4vw!important;
  }
  .div2 .spanp{
    height: 2vh;
    font-size: 1.2vw!important;
    font-family: Arial, Arial-Regular;
    font-weight: bold;
    color: #ffffff;
    letter-spacing: 0.088vw;
    margin-left: 0.8854vw;
  }
  .span1{
    text-align: center;
    width: 6.3vw;
    display: flex;
    flex-direction: column;
  }
  .span1 img{
width: 6.3021vw;
/* height: 11.4232vh; */
  }
  /deep/.bbbb{
    width: 6.3021vw!important;
     height: 6.3021vw!important;
  }
  .span2{
    position: absolute;
    margin-left:11.4583vw;
    margin-top: 18vh;
  }
  /deep/ .cccc {
    width: 6.3021vw!important;
    height: 6.3021vw!important;
  }
  .span3{
    margin-top: 0.5vw;
    height: 1.4981vh;
    font-size: 0.8375vw;
    font-family: PingFang SC, PingFang SC-Light;
    font-weight: 300;
    color: #dddddd;
  }
  .span4{
    position: absolute;
    margin-left:11.3021vw;
    margin-top: 33vh;
    height: 1.4981vh;
    font-size: 0.9vw!important;
    font-family: PingFang SC, PingFang SC-Light;
    font-weight: 300;
    color: #dddddd;
  }
  .span5{
    text-align: center;
  }
  .span5 a{
    padding: 2vw;
    height: 1.6854vh;
    font-size: 1.0417vw;
    font-family: PingFang SC, PingFang SC-Light;
    font-weight: 300;
    color: #dddddd;
  }
  .div3{
    width: 0.0521vw;
    height: 27vh;
    opacity: 0.5;
    background: #ffffff;
    position: absolute;
    margin-left:24.9479vw ;
    margin-top: 18vh;
  }
  .div4{
    padding: 2vw 8vw;
  display:grid;
  
  grid-template-columns:  14.28% 14.28% 14.28% 14.28% 14.28% 14.28% 14.28%;
  /*repeat重复函数*/
  grid-template-rows:repeat(7,14.28%);
  }
  .div4 .spano {
    font-family: PingFang SC, PingFang SC-Medium;
    padding-right: 3.3854vw!important;
    color: white !important;
    font-weight: 500;
    font-size: 1vw!important;
  }
  .div4 span {
    font-family: PingFang SC, PingFang SC-Medium;
    padding-right: 3.3854vw;
    color: white;
    font-weight: 500;
    font-size: 1.25vw;
  }

  li{
    padding-bottom: 1.4045vh;
    font-size: 1.0417vw;
    color: #A8A186;
    font-family: PingFang SC, PingFang SC-Medium;
  }

  .div5{
    width: 44.6042vw;
    height: 0.0521vw;
    background: #707070;
    position: absolute;
    margin-left: 48.6458vw;
    margin-top: 45.3184vh;
  }
  .div6{
    width: 42.4479vw;
    position: absolute;
    margin-top: 47vh;
    padding-left: 52.4896vw;
  }
  .div6 .span {
    height: 1.5vh;
    font-size: 0.8vw;
    font-family: PingFang SC, PingFang SC-Light;
    font-weight: 300;
    color: #b5b5b5;
    margin-right: 1.0417vw;
  }
</style>